module.exports = __webpack_public_path__ + "ac9e2b835c9e0e760c41101de412017f.svg";